import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { plainToClass } from 'class-transformer';
import { AbstractAppConfig } from '../../../app.config';
import { Observable, throwError } from 'rxjs';
import { Profile } from '../../domain';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { HttpErrorService } from '../http';

@Injectable()
export class ProfileService {

  public static readonly V2_MEDIATYPE_USER_PROFILE =
    'application/vnd.uk.gov.hmcts.ccd-data-store-api.ui-user-profile.v2+json;charset=UTF-8';
  public static readonly QC_V2_MEDIATYPE_USER_PROFILE =
    'application/vnd.app.quickcase.store.data.api.ui-user-profile.v2+json;charset=UTF-8';

  private static readonly URL = '/internal/profile';

  constructor(private httpClient: HttpClient, private appConfig: AbstractAppConfig, private errorService: HttpErrorService) {}

  get(): Observable<Profile> {
    let url = this.appConfig.getCaseDataUrl() + ProfileService.URL;
    let headers = new HttpHeaders({
      'Accept': [ProfileService.V2_MEDIATYPE_USER_PROFILE, ProfileService.QC_V2_MEDIATYPE_USER_PROFILE],
    });

    return this.httpClient
      .get<Profile>(url, {headers: headers})
      .pipe(
        map((p: Object) => plainToClass(Profile, p)),
        catchError(error => {
          this.errorService.setError(error);
          return throwError(error);
        })
      )
  }

}
